import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import  *  as axios from 'axios';
import * as urls from '../../../../constants/webapi/user';

export const DiscountCode = ({user, discountCodeState, setDiscountCodeState}) => {
    const [loadingState, setLoadingState] = useState(false);
    function validateDiscountCode(code){
        setLoadingState(true);
        return axios.post(urls.validateDiscountCodeUrl(user.id), {code: code})
            .then((response) => {
                setDiscountCodeState({...discountCodeState, isValid: true, code: response.data.code, apiId: response.data.apiId});
                setLoadingState(false);
            })
            .catch((error) => {
                setDiscountCodeState({...discountCodeState,isValid: false});
                setLoadingState(false);
            });
    }

    return (
        <>
            <h3 className="h3 text-secondary font-weight-bolder mt-3 mb-1">Code partenaire</h3>
            <p className="small o-80">Insérer le code partenaire ci-dessous</p>
            <form className="block container-wide">
                <div className="form-group my-xl-auto">
                    <label htmlFor="NombreS" className="label h6 lh-root font-weight-bold">Votre code</label>
                    <div className="input-group mb-0">
                        <input type="text" className={"form-control rounded" + (!R.isNil(discountCodeState.isValid) && !discountCodeState.isValid ? " is-invalid" : "")} id="NombreS" placeholder="xxxxxxxxxxx" aria-describedby="basic-addon2" onChange={
                            (e) => {
                                setDiscountCodeState({...discountCodeState, code: e.target.value});

                            }
                        } />
                        <span className="input-group-text ml-1 border-none p-0 bg-none" id="basic-addon2">
                            <button className={"btn btn-info loading-btn" + (loadingState ? " show" : "")} disabled={discountCodeState.isValid} onClick={
                            (e) => {
                                e.preventDefault();
                                validateDiscountCode(discountCodeState.code);
                            }
                            }>Appliquer <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button></span>
                    </div>
                    {
                        !R.isNil(discountCodeState.isValid) ?
                            !discountCodeState.isValid ?
                                <div className="invalid-feedback d-block">
                                    <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                                    <span className="align-middle text-dark o-70">Le code n'est pas valide. Veuillez réssayer.</span>
                                </div>
                            :
                                <p className="small text-gray mb-3 mt-2"><i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i>Code appliqué: le tarif a été mis à jour.</p>
                        :
                            ''
                    }
                </div>
            </form>
        </>
    );
}